// Derive status from your existing data
export const getTransactionStatusKey = (subscriptionStatus, state) => {
    if (subscriptionStatus === 1) return "success";
    if (subscriptionStatus === 3) return "error"; 
    if (state === "PENDING" || subscriptionStatus === 0 || subscriptionStatus === 2) return "pending";
    return "error";
};
